import { defineMessages } from 'react-intl-next';

export default defineMessages({
	dashboardButtonLabel: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.dashboard-button-label',
		defaultMessage: 'Dashboard',
		description: 'The label shown on the dashboard button in the Boysenberry sidebar.',
	},
	feedbackButtonLabel: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.feedback-button-label',
		defaultMessage: 'Help or feedback?',
		description: 'The label shown on the feedback button in the Boysenberry sidebar.',
	},
	sessionsButtonLabel: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.sessions-button-label',
		defaultMessage: 'Sessions',
		description: 'The label shown on the sessions button in the Boysenberry sidebar.',
	},
	newSessionTooltip: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.new-session-tooltip',
		defaultMessage: 'New session',
		description:
			'The tooltip shown when hovering the new session button in the Boysenberry sidebar.',
	},
	inProgressSessionSectionTitle: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.in-progress-session-section-title',
		defaultMessage: 'Recent',
		description: 'The title of the section show in progress sesssions in the Boysenberry sidebar.',
	},
	completedSessionSectionTitle: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.completed-session-section-title',
		defaultMessage: 'Completed',
		description: 'The title of the section show completed sesssions in the Boysenberry sidebar.',
	},
	viewAllSessionsLinkLabel: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.view-all-sessions-link-label',
		defaultMessage: 'View all sessions',
		description: 'The label shown on the view all sessions button in the Boysenberry sidebar.',
	},
	archiveSessionButtonLabel: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.archive-session-button-label',
		defaultMessage: 'Archive session',
		description: 'The label shown on the archive session button in the Boysenberry sidebar.',
	},
	archiveSessionWarningText: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.archive-session-warning-text',
		defaultMessage: 'This operation is irreversible, please ensure you have saved all your work.',
		description: 'The warning text shown in the confirmation modal when archiving a session.',
	},
	archiveSessionModalTitle: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.archive-session-modal-title',
		defaultMessage: 'Are you sure you want to archive this session?',
		description: 'The title of the confirmation modal when archiving a session.',
	},
	archiveSessionButtonTooltip: {
		id: 'dev-agents.boysenberry.layout-sidebar.components.archive-session-button-tooltip',
		defaultMessage: 'More actions',
		description:
			'The tooltip shown when hovering the archive session button in the Boysenberry sidebar.',
	},
});
